const PeriodsSettings = {
	period  : {
		value  : "период",
		gender : 1
	},
	half    : {
		value  : "тайм",
		gender : 1
	},
	set     : {
		value  : "сет",
		gender : 1
	},
	game    : {
		value  : "гейм",
		gender : 1
	},
	match   : {
		value  : "матч",
		gender : 1
	},
	quarter : {
		value  : "четверть",
		gender : 0
	},
	party   : {
		value  : "партия",
		gender : 0
	},
	frame   : {
		value  : "фрейм",
		gender : 1
	},
	map   : {
		value  : "карта",
		gender : 0
	}
};

export default PeriodsSettings;


// WEBPACK FOOTER //
// ./src/app/constants/PeriodsSettings.js